export default "__VITE_ASSET__CC8zY_Ym__"